import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import BlockDtDd from '../definition-list/block-dt-dd';
import DefinitionListHeader from '../definition-list/definition-list-header';
import IconBrands from '../icons/brands';

const columnsCount = {
  '2': 'grid-cols-2',
  '4': 'grid-cols-2 lg:grid-cols-4',
};

const TechInfo: FunctionComponent<{
  technical_info: TTechInfo;
  columns?: '2' | '4';
  showTitle?: boolean;
  key?: string;
}> = (
  {
    technical_info,
    columns = '2',
    key,
    showTitle = true,
    ref
  }
) => {
  const { t } = useTranslation();

  return (
    <div key={key} className={cx('py-4 max-md:px-4 max-lg:py-8 max-lg:container max-lg:mx-auto')}>
      <div
        id="pp_tec_info"
        ref={ref}
        className="scroll-mt-[316px] lg:scroll-mt-[190px] "
      ></div>
      {showTitle && <DefinitionListHeader
        titleClassName="text-blue-100"
        title={t('product:tec_info')}
      />}
      {technical_info ? (
        <dl className={cx('grid gap-x-4', columnsCount[columns])}>
          <BlockDtDd
            dt={t('product:drivetrain')}
            dd={technical_info.drive_type || '-'}
          />
          <BlockDtDd
            dt={t('product:construction_type')}
            dd={technical_info.body_type || '-'}
          />
          <BlockDtDd
            dt={t('product:fuel_type')}
            dd={technical_info.fuel_type || '-'}
          />
          <BlockDtDd
            dt={t('product:engine_type')}
            dd={technical_info.engine_type || '-'}
          />
          <BlockDtDd dt={t('product:power')} dd={technical_info.power || '-'} />
          <BlockDtDd
            dt={t('product:brake_type')}
            dd={technical_info.brake_type || '-'}
          />
          <BlockDtDd
            dt={t('product:no_of_cylinders')}
            dd={technical_info.cylinder_nr || '-'}
          />
          <BlockDtDd
            dt={t('product:catalyst_type')}
            dd={technical_info.catalyst_type || '-'}
          />
          <BlockDtDd
            dt={t('product:displacement')}
            dd={technical_info.displacement || '-'}
          />
          <BlockDtDd
            dt={t('product:brake_system')}
            dd={technical_info.brake_system || '-'}
          />
          <BlockDtDd
            dt={t('product:no_of_valves')}
            dd={technical_info.valve_nr || '-'}
          />
          <BlockDtDd
            dt={t('product:transmission')}
            dd={technical_info.transmission_type || '-'}
          />
        </dl>
      ) : (
        <p className={cx('text-sm')}>{t('product:no_tec_info')}</p>
      )}
    </div>
  );
};

export default TechInfo;
